export default __webpack_public_path__ + "static/media/language.5ed2c464.svg";